import { render, staticRenderFns } from "./Publishing.vue?vue&type=template&id=23919b31&scoped=true&"
import script from "./Publishing.vue?vue&type=script&lang=js&"
export * from "./Publishing.vue?vue&type=script&lang=js&"
import style0 from "./Publishing.vue?vue&type=style&index=0&id=23919b31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23919b31",
  null
  
)

export default component.exports